import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_CUSTOMER_TYPE, APP_EVENT_TYPE } from "./Customerpath";
import { ALLOWED_MODULES } from "../../constants/enums";





const CustomerType = Loadable(
    lazy(() =>
        import("./CustomerType").then(({ CustomerType }) => ({
            default: CustomerType,
        }))
    )
);

const EventType = Loadable(
    lazy(() =>
        import("./EventType").then(({ EventType }) => ({
            default: EventType,
        }))
    )
);

export const customerTypeRoutes = [
    {
    path: APP_CUSTOMER_TYPE,
            exact: true,
            element: (
                <AuthorizedRoute
                    allowFullAccess
                    moduleIds={[ALLOWED_MODULES.LEADS]}
                >
                    <CustomerType />
                </AuthorizedRoute>
            ),

},
]

export const eventTypeRoutes = [
  {
    path: APP_EVENT_TYPE,
    exact: true,
    element: (
        <AuthorizedRoute
            allowFullAccess
            moduleIds={[ALLOWED_MODULES.LEADS]}
        >
            <EventType />
        </AuthorizedRoute>
    ),
},
]